import { createRoot } from "react-dom/client";
import "./style.css";
import App from "./chat/App";

// 注：此应用用 useRef 保存流程状态机（phase/currentStep 等），依赖 effect 只运行一次；
// React.StrictMode 会在开发模式下双重触发 effect 导致流程重复执行，故不在此处启用。
createRoot(document.getElementById("root")!).render(<App />);
